import React, { FC, Fragment } from 'react';
import { InputLabel } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { Tip, ValidatedTextFieldNext } from 'components';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  textField: {
    fontSize: theme.spacing(4),
    fontWeight: 'bold',
    margin: theme.spacing(1, 0),
  },
}));

const Title: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Fragment>
      <InputLabel shrink>{t('contentEmails:emailTitleLabel')}</InputLabel>
      <ValidatedTextFieldNext
        fullWidth
        name="title"
        placeholder={t('contentEmails:createPlaceholder')}
        InputProps={{ className: classes.textField }}
      />
      <Tip i18nKey="contentEmails:titleTip" disableMargin />
    </Fragment>
  );
};

export default Title;
